// FetchPositions.js
import React from 'react';
import { useFetchPositions } from '../hooks/DataFetching/useFetchPositions';

export const FetchPositions = () => {
    const { positions, loading } = useFetchPositions();

    const renderPositionsTable = (positions) => {
        return (
            <table className='table table-striped' aria-labelledby="tabelLabel">
                <thead>
                    <tr>
                        <th>Id</th>
                        <th>GroupId</th>
                        <th>CampaignId</th>
                        <th>PositionDescription</th>
                        <th>PositionDuties</th>
                        <th>HireDate</th>
                        <th>EndDate</th>
                        <th>WeeklyCompensation</th>
                        <th>MemberId</th>
                        <th>PositionStatus</th>
                        <th>CreatedOn</th>
                    </tr>
                </thead>
                <tbody>
                    {positions.map(position =>
                        <tr key={position.id}>
                            <td>{position.id}</td>
                            <td>{position.groupId}</td>
                            <td>{position.campaignId}</td>
                            <td>{position.positionDescription}</td>
                            <td>{position.positionDuties}</td>
                            <td>{position.hireDate}</td>
                            <td>{position.endDate}</td>
                            <td>{position.weeklyCompensation}</td>
                            <td>{position.memberId}</td>
                            <td>{position.positionStatus}</td>
                            <td>{position.createdOn}</td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    };

    let contents = loading ? (
        <p>
            <em>Loading...</em>
        </p>
    ) : renderPositionsTable(positions);

    return (
        <div>
            <h1 id="tabelLabel">Positions</h1>
            <p>This component demonstrates fetching data from the server.</p>
            {contents}
        </div>
    );
};

